import React, { useState } from "react";
import styles from "./OtAction.module.scss";
import thumbsUp from "../../assets/images/thumbs-up.svg";
import moment from "moment-timezone";

import api from "../../libs/api";
import Tracking from "@magic-engineering/magic-tracking";
import { Alert, Button } from "@magic-engineering/components";

const OtAction = ({ ot, assistant, onClose }) => {
  Tracking.otRequestViewed();

  const [updatingStatus, setUpdatingStatus] = useState("");

  const onClick = async (status) => {
    try {
      setUpdatingStatus(status);
      if (status === "APPROVED") {
        Tracking.otRequestApproved();
      }
      if (status === "DENIED") {
        Tracking.otRequestDenied();
      }
      await api.put(`/dtrs/ots/${ot.ot_request_id}`, { status });
      if (onClose) onClose(status);
    } catch (error) {
      console.error(error);
    } finally {
      setUpdatingStatus("");
    }
  };

  const alertContent = (
    <div>
      <p>
        {assistant.name} is requesting {ot.hours} extra hours for the week of{" "}
        {getWeekStartEnd(ot.created_at)}.
      </p>
      <p>Reason: "{ot.user_reason}"</p>
      <div className={styles.ActionButtons}>
        <Button
          icon={<img className={styles.ButtonIcon} src={thumbsUp} alt="approve" />}
          label={updatingStatus === "APPROVED" ? "APPROVING..." : "APPROVE"}
          onClick={() => onClick("APPROVED")}
          dataTestId="ApproveButton"
          className={styles.Button}
          disabled={updatingStatus}/>
        <Button
          icon={<img className={`${styles.ButtonIcon} ${styles.FlipY}`} src={thumbsUp} alt="deny" />}
          label={updatingStatus === "DENIED" ? "DENYING..." : "DENY"}
          onClick={() => onClick("DENIED")}
          dataTestId="DenyButton"
          className={styles.Button}
          disabled={updatingStatus}
          type="Warning"/>
      </div>
    </div>
  );

  return (
    <div className={`mb-4 ${styles.OtAction}`} data-testid="OtAction">
      <Alert
        title="Action Required: Extra Hours Requested"
        text={alertContent}
        />
    </div>
  );
};

export function getWeekStartEnd(date) {
  const defaultWeekStart = 4; // THURSDAY UTC after 23:00 / FRIDAY PHT after 7AM
  let today = moment(date).tz("UTC");

  /*
    get cutoff date
    if today < cutoff date
      start = cutoff date - 7
      end = cutoff date
    else
      start = cutoff
      end = cutoff + 7
  */
  const cutoffTime = { hours: 23, minutes: 0 };
  let cutoffDate = today.clone().set(cutoffTime);

  if (today.day() !== defaultWeekStart) {
    let daysAway = defaultWeekStart - today.day();
    if (daysAway <= 0) {
      daysAway = Math.abs(daysAway) + defaultWeekStart + 1;
    }
    cutoffDate = today.clone().add(daysAway, "days").set(cutoffTime);
  }

  const weekStartDay = cutoffDate.clone();

  if (today.isBefore(cutoffDate)) {
    weekStartDay.subtract(7, "days");
  }

  weekStartDay.add(1, "day"); // Thursday is converted to Friday

  const weekEndDay = weekStartDay.clone().add(6, "days");

  const start = weekStartDay.format("MMMM D");
  let end = weekEndDay.format("D, YYYY");

  if (weekStartDay.month() !== weekEndDay.month()) {
    end = weekEndDay.format("MMMM D, YYYY");
  }

  return start + "-" + end;
}

export default OtAction;
